import React from 'react';
import { StyledEmptyState, StyledEmptyStateDescription, StyledEmptyStateHeading } from './EmptyState.styled';
export function EmptyState(props) {
  var EmptyIcon = props.icon;
  return /*#__PURE__*/React.createElement(StyledEmptyState, null, props.title && /*#__PURE__*/React.createElement(StyledEmptyStateHeading, null, props.title), /*#__PURE__*/React.createElement(EmptyIcon, {
    size: 120
  }), props.children && /*#__PURE__*/React.createElement(StyledEmptyStateDescription, null, props.children));
}